import {createActions} from 'client/framework';

const normalActions = [
  'TOGGLE_DIFFICULTY',
  'TOGGLE_INCLUDE_ANSWER_STATUS',
  'RESET_FILTERS',
  'SET_SORT_BY',
  'SET_IS_OPEN'
];

export default createActions(null, normalActions);
